const registrar_solicitacao_de_transferencia = {
  path: "/registrar-solicitacao-de-transferencia",
  redirect: "/registrar-solicitacao-de-transferencia",
  meta: {
    breadCrumb: "Processo de Matrículas - Transferência do Aluno",
  },
  children: [
    {
      path: "/registrar-solicitacao-de-transferencia",
      name: "registrar-solicitacao-de-transferencia",
      component: () =>
        import(
          "@/views/RegistrarSolicitacaoDeTransferencia/RegistrarSolicitacaoDeTransferencia.vue"
        ),
    },
  ],
};

export { registrar_solicitacao_de_transferencia };
